import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useContext } from 'preact/compat';
import { ConfigCTX } from '@basket/context/config';
import { useCallback } from 'react';
import { Icon, Title, TitleWrapper, Wrapper, } from './styles';
function BasketHeader(props) {
    const { basketTitle, basketIcon, isModal, modalId, } = useContext(ConfigCTX);
    const buttonEvent = useCallback(() => {
        if (isModal) {
            // close modal
            window.dispatchEvent(new CustomEvent('basket.closed'));
            return;
        }
        // basket page so go back
        history.back();
    }, [isModal]);
    return (_jsxs(Wrapper, { children: [_jsxs(TitleWrapper, { children: [_jsx(Icon, { width: "25", height: "25", className: "basket-menu__icon", children: _jsx("use", { xlinkHref: `#icon--${basketIcon}` }) }), _jsx(Title, { children: basketTitle })] }), _jsx("button", { type: "button", className: "close", onClick: buttonEvent, "aria-label": "Close basket", children: _jsx("svg", { children: _jsx("use", { xlinkHref: "#icon--tooltip-close" }) }) })] }));
}
export default BasketHeader;
